import React, { Fragment } from "react";
import {
  Datagrid,
  TextField,
  FunctionField,
  ReferenceField,
  ListProps,
  useDataProvider,
  Button,
  List,
  Filter,
  SearchInput,
  useNotify,
} from "react-admin";
import { Helmet } from "react-helmet";
import CustomDateField from "components/CustomDateField";
import { SchoolIdSelected } from "utils/tools";
import CustomPriceField from "components/CustomPriceField";

const CustomerReceiptsList = (props: ListProps) => {
  const provider = useDataProvider();
  const notify = useNotify();

  const CustomerReceiptsFilter = (props: any) => (
    <Filter {...props}>
      <SearchInput source="search" alwaysOn />
    </Filter>
  );

  const GetPdf = (id: number) => {
    provider
      .getOne("customerReceipts", {
        id: id,
      })
      .then(({ data }) => {
        window.open(data.pdfUrl, "_blank");
      })
      .catch((error: any) => {
        notify("PDF is generating...");
      });
  };

  const ShowPdfButton = (props: any) => {
    console.log("pdf data", props.data);
    return (
      <>
        <Button
          onClick={() => {
            GetPdf(props.data.id);
          }}
          label="Show PDF"
        />
      </>
    );
  };

  return (
    <>
      <Helmet>
        <title>Receipts</title>
      </Helmet>
      <List
        title={"Receipts"}
        exporter={false}
        filters={<CustomerReceiptsFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={false}
        {...props}
      >
        <Datagrid>
          <ReferenceField
            source="parentId"
            reference="parents"
            label="Parent"
            link={false}
          >
            <FunctionField
              render={(record: any) => (
                <div>
                  {record.firstName} {record.lastName}
                </div>
              )}
            />
          </ReferenceField>

          <CustomDateField source="createdAt" />
          <TextField label="Description" source="description" emptyText="-" />
          <CustomPriceField source="amount" />

          <FunctionField
            label="Action"
            render={(record: any) => {
              return (
                <>
                  <ShowPdfButton data={record} />
                </>
              );
            }}
          />
        </Datagrid>
      </List>
    </>
  );
};

export default CustomerReceiptsList;
